<template>
  <Dialog
    :model-value="visible"
    :title="dialogTitle"
    dialog-type="primary"
    dialog-size="small"
    :close-on-overlay="false"
    @update:model-value="(v) => { if (!v) closeDialog() }"
    @close="closeDialog"
  >
    <template #header-icon>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9C10.34 9 9 10.34 9 12ZM13 12C13 12.55 12.55 13 12 13C11.45 13 11 12.55 11 12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12Z" fill="white"/>
        <path d="M8 10V8H5.09C6.47 5.61 9.05 4 12 4C15.72 4 18.85 6.56 19.74 10H21.8C20.87 5.44 16.84 2 12 2C8.73 2 5.82 3.58 4 6.01V4H2V10H8Z" fill="white"/>
        <path d="M16 14V16H18.91C17.53 18.39 14.95 20 12 20C8.28 20 5.15 17.44 4.26 14H2.2C3.13 18.56 7.16 22 12 22C15.27 22 18.18 20.42 20 17.99V20H22V14H16Z" fill="white"/>
      </svg>
    </template>
    <p class="confirmation-message" v-html="confirmationMessage" />

    <template #footer>
      <ResponsiveButton button_type="outlined" built_in_theme="error" size="medium" @click="closeDialog">No, do not convert.</ResponsiveButton>
      <ResponsiveButton button_type="filled" built_in_theme="dark" size="medium" @click="handleConvert">Yes, convert.</ResponsiveButton>
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'ConvertWorkflowDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    workflowName: {
      type: String,
      default: 'Customized Workflow 1'
    },
    isProgram: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'convert'],
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    },
    dialogTitle() {
      return this.isProgram 
        ? 'Convert Program to Workflow' 
        : 'Convert Workflow to Program';
    },
    confirmationMessage() {
      if (this.isProgram) {
        // Program to Workflow
        return `You are about to convert <strong>${this.workflowName}</strong> to a Workflow. This will replace the original program with the workflow. You can convert it back to a program anytime. Are you sure you want to continue?`;
      } else {
        // Workflow to Program
        return `You are about to convert <strong>${this.workflowName}</strong> to a Program. This will replace the original workflow with the program. You can only revert it to a workflow when it's not assigned to any patient. Are you sure you want to continue?`;
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    handleConvert() {
      this.$emit('convert');
      this.closeDialog();
    }
  }
};
</script>

<style scoped>
.confirmation-message {
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  color: #374957;
  margin: 0;
  padding: 16px 8px
}
</style>
